// team id -> team name conversion
export const nflTeams = {
    "NYG":"Giants",
    "SF":"49ers",
    "TEN":"Titans",
    "CLE":"Browns",
    "ATL":"Falcons",
    "DET":"Lions",
    "NO":"Saints",
    "GB":"Packers",
    "HOU":"Texans",
    "JAX":"Jaguars",
    "DEN":"Broncos",
    "MIA":"Dolphins",
    "LAC":"Chargers",
    "MIN":"Vikings",
    "NE":"Patriots",
    "NYJ":"Jets",
    "IND":"Colts",
    "BAL":"Ravens",
    "BUF":"Bills",
    "WAS":"Commanders",
    "CAR":"Panthers",
    "SEA":"Seahawks",
    "DAL":"Cowboys",
    "ARI":"Cardinals",
    "CHI":"Bears",
    "KC":"Chiefs",
    "PIT":"Steelers",
    "LV":"Raiders",
    "PHI":"Eagles",
    "TB":"Buccaneers",
    "CIN":"Bengals",
    "LAR":"Rams",
};

export const nflTeamIds = {
    "ARI": 1,
    "ATL": 2,
    "BAL": 3,
    "BUF": 4,
    "CAR": 5,
    "CHI": 6,
    "CIN": 7,
    "CLE": 8,
    "DAL": 9,
    "DEN": 10,
    "DET": 11,
    "GB": 12,
    "HOU": 13,
    "IND": 14,
    "JAX": 15,
    "KC": 16,
    "LAC": 29,
    "LAR": 32,
    "LV": 25,
    "MIA": 19,
    "MIN": 20,
    "NE": 21,
    "NO": 22,
    "NYG": 23,
    "NYJ": 24,
    "PHI": 26,
    "PIT": 28, 
    "SEA": 30,
    "SF": 31,
    "TB": 33, 
    "TEN": 34,
    "WAS": 35
};

export const nflConferences = {
    "AFC": {
        "East": ["BUF", "MIA", "NE", "NYJ"],
        "North": ["BAL", "CIN", "CLE", "PIT"],
        "South": ["HOU", "IND", "JAX", "TEN"],
        "West": ["DEN", "KC", "LV", "LAC"]
    },
    "NFC": {
        "East": ["DAL", "NYG", "PHI", "WAS"],
        "North": ["CHI", "DET", "GB", "MIN"],
        "South": ["ATL", "CAR", "NO", "TB"],
        "West": ["ARI", "LAR", "SF", "SEA"]
    }
};
export const nflStatVerbs = {
    "off.rushing" : {
        "off.rushing.att": "are",
        "off.rushing.yds": "are",
        "off.rushing.tds": "are",
        "off.rushing.long": "is",
        "off.rushing.first_downs": "are",
        "off.rushing.ybc": "are",
        "off.rushing.yac": "are",
        "off.rushing.broken_tackles": "are"
    },
    "off.passing":{ 
        "off.passing.att": "are",
        "off.passing.comp": "are",
        "off.passing.yds": "are",
        "off.passing.tds": "are",
        "off.passing.ints": "are",
        "off.passing.net_yds": "are",
        "off.passing.pass_rating": "is",
        "off.passing.long": "is",
        "off.passing.first_downs": "are",
        "off.passing.intended_air_yds": "are",
        "off.passing.comp_air_yds": "are",
        "off.passing.yac": "are",
        "off.passing.poor_throws": "are",
        "off.passing.blitzed": "are",
        "off.passing.hurried": "are",
        "off.passing.hits_taken": "are",
        "off.passing.pressured": "are",
        "off.passing.scrambles": "are",
        "off.passing.scramble_yds": "are",
        "off.passing.dropbacks": "are",
        "off.passing.spikes_throwaways": "are",
        "off.sacks.taken": "are",
        "off.sacks.yds_lost": "are"
    },
    "off.receiving": {
        "off.receiving.ybc": "are",
        "off.receiving.yac": "are",
        "off.receiving.broken_tackles": "are",
        "off.receiving.first_downs": "are",
        "off.receiving.drops": "are"
    },
    "off.general": {
        "off.first_downs": "are",
        "off.third_downs.att": "are", 
        "off.third_downs.conv": "are",
        "off.fourth_downs.att": "are", 
        "off.fourth_downs.conv": "are",
        "off.total_yds": "are",
        "off.fumbles": "are",
        "off.fumbles_lost": "are", 
        "off.turnovers": "are",
        "off.possession": "are"
    },
    "def.passing": {
        "def.passing.ints": "are",
        "def.passing.int_yds": "are",
        "def.passing.int_tds": "are",
        "def.passing.int_long": "is",
        "def.passing.passes_defended": "are"
    },
    "def.tackles": {
        "def.tackles.sacks": "are",
        "def.tackles.solo": "are",
        "def.tackles.assists": "are",
        "def.tackles.for_loss": "are",
        "def.tackles.qb_hits": "are",
        "def.missed_tackles": "are"
    },
    "def.fumbles": {
        "def.fumbles.recovered": "are",
        "def.fumbles.yds_ret": "are",
        "def.fumbles.tds": "are",
        "def.fumbles.forced": "are"
    },
    "def.general": {
        "def.player_blitzes": "are",
        "def.player_hurries": "are",
        "def.qb_knockdowns": "are",
        "def.player_pressures": "are"
    },
    "st.kicking": {
        "st.kicking.punt": "are", 
        "st.kicking.punt_yds": "are",
        "st.kicking.punt_long": "is",
        "st.kicking.xpm": "are",
        "st.kicking.xpa": "are",
        "st.kicking.fgm": "are",
        "st.kicking.fga": "are"
    }
};

export const nflStats = {
    "off.rushing" : {
        "off.rushing.att": "rushing attempts",
        "off.rushing.yds": "rushing yards",
        "off.rushing.tds": "rushing tds",
        "off.rushing.long": "longest rush",
        "off.rushing.first_downs": "first downs rushing",
        "off.rushing.ybc": "yards before contact",
        "off.rushing.yac": "yards after contact",
        "off.rushing.broken_tackles": "broken tackles"
    },
    "off.passing": {
        "off.passing.att": "passing attempts",
        "off.passing.comp": "passing completions",
        "off.passing.yds": "passing yards",
        "off.passing.tds": "passing touchdowns",
        "off.passing.ints": "interceptions thrown",
        "off.passing.net_yds": "net passing yards",
        "off.passing.pass_rating": "pass rating",
        "off.passing.long": "longest pass",
        "off.passing.first_downs": "first downs passing",
        "off.passing.intended_air_yds": "intended air yards",
        "off.passing.comp_air_yds": "completed air yards",
        "off.passing.yac": "yards after catch",
        "off.passing.poor_throws": "poor throws",
        "off.passing.blitzed": "qb times blitzed",
        "off.passing.hurried": "qb times hurried",
        "off.passing.hits_taken": "qb hits taken",
        "off.passing.pressured": "qb times pressured",
        "off.passing.scrambles": "scrambles",
        "off.passing.scramble_yds": "scramble yards",
        "off.passing.dropbacks": "dropbacks",
        "off.passing.spikes_throwaways": "spikes and throwaways",
        "off.sacks.taken": "sacks taken",
        "off.sacks.yds_lost": "yards lost from sacks",
    },
    "off.receiving": {
        "off.receiving.ybc": "receiving yards before contact",
        "off.receiving.yac": "receiving yards after contact",
        "off.receiving.broken_tackles": "broken tackles",
        "off.receiving.first_downs": "first downs receiving",
        "off.receiving.drops": "passes dropped"
    },
    "off.general": {
        "off.first_downs": "offensive first downs",
        "off.third_downs.att": "third down attempts", 
        "off.third_downs.conv": "third down conversions",
        "off.fourth_downs.att": "fourth down attempts", 
        "off.fourth_downs.conv": "fourth down conversions",
        "off.total_yds": "total offensive yards",
        "off.fumbles": "fumbles",
        "off.fumbles_lost": "fumbles lost", 
        "off.turnovers": "turnovers",
        "off.possession": "minutes of possession"
    },
    "def.passing": {
        "def.passing.ints": "defensive interceptions",
        "def.passing.int_yds": "interception yards returned",
        "def.passing.int_tds": "pick sixes",
        "def.passing.int_long": "longest interception return",
        "def.passing.passes_defended": "passes defended"
    },
    "def.tackles": {
        "def.tackles.sacks": "defensive sacks",
        "def.tackles.solo": "solo tackles",
        "def.tackles.assists": "assisted tackles",
        "def.tackles.for_loss": "tackles for a loss",
        "def.tackles.qb_hits": "defensive qb hits",
        "def.missed_tackles": "missed tackles"
    },
    "def.fumbles": {
        "def.fumbles.recovered": "fumbles recovered",
        "def.fumbles.yds_ret": "fumble yards returned",
        "def.fumbles.tds": "fumbles returned for a touchdown",
        "def.fumbles.forced": "forced fumbles"
    },
    "def.general": {
        "def.player_blitzes": "players sent on a blitz",
        "def.player_hurries": "total players who hurried the qb",
        "def.qb_knockdowns": "qb knockdowns",
        "def.player_pressures": "total players who pressured the qb",
    },
    "st.kicking": {
        "st.kicking.punt": "punts", 
        "st.kicking.punt_yds": "punt yards",
        "st.kicking.punt_long": "longest punt",
        "st.kicking.xpm": "extra points made",
        "st.kicking.xpa": "extra points attempted",
        "st.kicking.fgm": "field goals made",
        "st.kicking.fga": "field goals attempted"
    }
};

export const isHigherBetter = {
    "off.rushing.att": true,
    "off.rushing.yds": true,
    "off.rushing.tds": true,
    "off.rushing.long": true,
    "off.rushing.first_downs": true,
    "off.rushing.ybc": true,
    "off.rushing.yac": true,
    "off.rushing.broken_tackles": true,
    "off.passing.att": true,
    "off.passing.comp": true,
    "off.passing.yds": true,
    "off.passing.tds": true,
    "off.passing.ints": false,
    "off.passing.net_yds": true,
    "off.passing.pass_rating": true,
    "off.passing.long": true,
    "off.passing.first_downs": true,
    "off.passing.intended_air_yds": true,
    "off.passing.comp_air_yds": true,
    "off.passing.yac": true,
    "off.passing.poor_throws": false,
    "off.passing.blitzed": false,
    "off.passing.hurried": false,
    "off.passing.hits_taken": false,
    "off.passing.pressured": false,
    "off.passing.scrambles": true,
    "off.passing.scramble_yds": true,
    "off.passing.dropbacks": true,
    "off.passing.spikes_throwaways": false,
    "off.sacks.taken": false,
    "off.sacks.yds_lost": false,
    "off.receiving.ybc": true,
    "off.receiving.yac": true,
    "off.receiving.broken_tackles": true,
    "off.receiving.first_downs": true,
    "off.receiving.drops": false,
    "off.first_downs": true,
    "off.third_downs.att": true, 
    "off.third_downs.conv": true,
    "off.fourth_downs.att": true, 
    "off.fourth_downs.conv": true,
    "off.total_yds": true,
    "off.fumbles": false,
    "off.fumbles_lost": false, 
    "off.turnovers": false,
    "off.possession": true,
    "def.passing.ints": true,
    "def.passing.int_yds": true,
    "def.passing.int_tds": true,
    "def.passing.int_long": true,
    "def.passing.passes_defended": true,
    "def.tackles.sacks": true,
    "def.tackles.solo": true,
    "def.tackles.assists": true,
    "def.tackles.for_loss": true,
    "def.tackles.qb_hits": true,
    "def.missed_tackles": false,
    "def.fumbles.recovered": true,
    "def.fumbles.yds_ret": true,
    "def.fumbles.tds": true,
    "def.fumbles.forced": true,
    "def.player_blitzes": true,
    "def.player_hurries": true,
    "def.qb_knockdowns": true,
    "def.player_pressures": true,
    "st.kicking.punt": false, 
    "st.kicking.punt_yds": true,
    "st.kicking.punt_long": true,
    "st.kicking.xpm": true,
    "st.kicking.xpa": true,
    "st.kicking.fgm": true,
    "st.kicking.fga": true,
    "off.offensive_plays": true,
    "off.first_downs_penalties": true,
    "off.negative_plays": false,
    "off.broken_tackles": true,
    "off.tds_total": true,
    "off.scoring.1": true,
    "off.scoring.2": true,
    "off.scoring.3": true,
    "off.scoring.4": true,
    "off.scoring.1H": true,
    "off.scoring.2H": true,
    "off.scoring.FG": true,
    "off.redzone.att": true,
    "off.redzone.conv": true,
    "def.defensive_plays": false,
    "def.first_downs_total": false,
    "def.first_downs_rushing": false,
    "def.first_downs_passing": false,
    "def.first_downs_penalties": false,
    "def.third_down_att": false,
    "def.third_down_conv": false,
    "def.fourth_down_att": false,
    "def.fourth_down_conv": false,
    "def.redzone_att": false,
    "def.redzone_conv": false, 
    "def.yds_total": false,
    "def.yds_rushing": false,
    "def.yds_passing": false,
    "def.tds_total": false, 
    "def.tds_rush": false,
    "def.tds_pass": false,
    "def.pass_att": false,
    "def.pass_comp": false,
    "def.pass_air_yds": false,
    "def.pass_int_air_yds": false,
    "def.pass_dropbacks": false,
    "def.pass_rating": false,
    "def.negative_plays": false,
    "def.rush_ybc": false,
    "def.rush_yac": false,
    "def.rush_att": false,
    "def.rec_yac": false, 
    "def.rec_ybc": false,
    "def.rec_targets": false,
    "def.pts_allowed.1": false,
    "def.pts_allowed.2": false,
    "def.pts_allowed.3": false,
    "def.pts_allowed.4": false,
    "def.pts_allowed.1H": false,
    "def.pts_allowed.2H": false,
    "def.pts_allowed.FG": false,
    "calculated.def.pct_pts_1h": false,
    "calculated.def.pct_pts_2h": false,
    "calculated.def.first_downs_per_play": false,
    "calculated.def.first_downs_per_rush": false,
    "calculated.def.first_downs_per_pass": false,
    "calculated.def.first_down_rush_pct": false,
    "calculated.def.first_down_pass_pct": false,
    "calculated.def.first_down_penalty_pct": false,
    "calculated.def.rush_rate": false,
    "calculated.def.pass_rate": false,
    "calculated.def.pass_td_pct": false, 
    "calculated.def.rush_td_pct": false, 
    "calculated.def.negative_play_rate": true,
    "calculated.def.yds_per_play": false,
    "calculated.def.yds_per_carry": false, 
    "calculated.def.yds_per_pass_comp": false,
    "calculated.def.yds_per_pass_att": false,
    "calculated.def.air_yds_per_pass_comp": false,
    "calculated.def.yac_per_comp": false,
    "calculated.def.pass_yac_pct": false, 
    "calculated.def.pass_ybc_pct": false,
    "calculated.def.rush_yac_pct": false,
    "calculated.def.rush_ybc_pct": false,
    "calculated.def.rush_avg_ybc": false,
    "calculated.def.rush_avg_yac": false,
    "calculated.def.pressure_rate": true,
    "calculated.def.pass_comp_pct": false,
    "calculated.def.int_rate": true, 
    "calculated.def.adot": false,
    "calculated.def.third_down_conv_rate": false,
    "calculated.def.fourth_down_conv_rate": false,
    "calculated.def.redzone_conv_rate": false,
    "calculated.off.pct_pts_1h": true,
    "calculated.off.pct_pts_2h": true,
    "calculated.off.pass_rate": true,
    "calculated.off.rush_rate": true,
    "calculated.off.first_downs_per_play": true,
    "calculated.off.first_downs_per_rush": true,
    "calculated.off.first_downs_per_pass": true,
    "calculated.off.first_down_rush_pct": true,
    "calculated.off.first_down_pass_pct": true,
    "calculated.off.first_down_penalty_pct": true,
    "calculated.off.seconds_per_play": true,
    "calculated.off.plays_per_min_poss": true,
    "calculated.off.yds_per_play": true,
    "calculated.off.yds_per_carry": true, 
    "calculated.off.yds_per_pass_comp": true,
    "calculated.off.yds_per_pass_att": true, 
    "calculated.off.air_yds_per_pass_comp": true,
    "calculated.off.yac_per_comp": true,
    "calculated.off.ybc_per_comp": true,
    "calculated.off.pass_td_pct": true, 
    "calculated.off.rush_td_pct": true,
    "calculated.off.negative_play_rate": false,
    "calculated.off.pass_yac_pct": true,             
    "calculated.off.pass_ybc_pct": true,
    "calculated.off.rush_yac_pct": true,
    "calculated.off.rush_ybc_pct": true,
    "calculated.off.rush_avg_ybc": true,
    "calculated.off.rush_avg_yac": true,
    "calculated.off.pressure_to_sack_rate": true,
    "calculated.off.comp_pct": true,
    "calculated.off.adj_comp_pct": true,
    "calculated.off.pressure_rate": false,
    "calculated.off.sack_rate": false,
    "calculated.off.bad_throw_rate": false,
    "calculated.off.int_rate": false,
    "calculated.off.scramble_rate": true,
    "calculated.off.yds_per_scramble": true,
    "calculated.off.btk_rate": true,
    "calculated.off.rec_btk_rate": true,
    "calculated.off.rush_btk_rate": true,
    "calculated.off.drop_rate": false,
    "calculated.off.redzone_conv_rate": true,
    "calculated.off.third_down_conv_rate": true,
    "calculated.off.fourth_down_conv_rate": true
};